import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { requestS3URL } from '../../../services/web-api-client';
import { CloudFrontSigner } from '../../../utils/cloud-front-signer/cloud-front-signer';
import { GLTFTDescriptor } from '../../../viewer/utilities/octTree/octTreeParser';
import { ScanStore } from './scan-store';

export class SignedCloudFrontUrlScanStore implements ScanStore {
  constructor(
    private scanCloudFrontSigner: CloudFrontSigner,
    private scanId: string,
  ) {}

  /**
   *  Returns the descriptor object from S3 using the signed request.
   *
   *  TODO: Descriptor does not exist in the same S3 storage as the chunks ({id}/descriptorFile vs. 2.0/{id}/geometry-chunks).
   *  This is a limit / bug / oversight in the current implementation after a mesh format transformation.
   *  It is not accessible as it resides in another path that the signed request allows access to.
   *
   *  This requires migrating existing gltft data gather the data to the same path.
   *  As the existing scan-format (TLS) is planned to be replaced, migration work might not be prioritized.
   */
  async fetchDescriptor(): Promise<GLTFTDescriptor> {
    const { url } = await SkyMapAxiosServiceFactory.instance
      .createScanServiceV0()
      .getDescriptor({ body: { id: this.scanId } });
    const descriptor = await requestS3URL(url);

    return JSON.parse(descriptor.data) as GLTFTDescriptor;
  }

  /**
   *  Returns the signed CloudFront url for the gltf file path.
   *  @param path - The path for the gltf  file.
   */
  fetchGltfUrl(part: string): Promise<string> {
    return Promise.resolve(this.scanCloudFrontSigner.getSignedRequest(`${part}`));
  }
}
